import { ROUTES } from '@/app/routes';

export type ClientRouteState = {
	from: string;
};

export function buildClientPath(clientId: string): string {
	return `${ROUTES.client}${clientId}`;
}

export function buildClientRouteState(fromPathname: string, search = ''): ClientRouteState {
	return { from: `${fromPathname}${search}` };
}

export function isClientRouteState(value: unknown): value is ClientRouteState {
	if (!value || typeof value !== 'object') return false;
	const from = (value as ClientRouteState).from;
	return typeof from === 'string' && from.length > 0;
}
